import { useMutation, useQuery, useQueryClient } from "react-query";
import axios from "axios";
import { message } from "antd";
import { useAuthStore } from "../../stores/useAuthStore";
import { useMerchantStore } from "../../stores/useMerchantStore";

export function useBids(data: { skip?: number; take?: number; reviewStatus: string }) {
  const authStore = useAuthStore();
  const merchantStore = useMerchantStore();

  return useQuery(["bids", data, merchantStore.selectedMerchant], async () => {
    if (!authStore.token || !merchantStore.selectedMerchant) return;

    const response = await axios.get<{ cars: []; total: number }>(
      `/backend/merchants/${merchantStore.selectedMerchant}/customer-cars`,
      {
        params: data,
      }
    );

    return response.data;
  });
}

export function useUpdateBid() {
  const merchantStore = useMerchantStore();
  const queryClient = useQueryClient();

  return useMutation(
    ["bid", "update"],
    (data: { customerCarId: number; price: number }) => {
      return axios.post(
        `/backend/merchants/${merchantStore.selectedMerchant}/customer-cars/${data.customerCarId}/bid`,
        data
      );
    },
    {
      onSuccess: () => {
        message.success("競標成功");
        queryClient.invalidateQueries("bigLogs");
      },
    }
  );
}

// export function useBidLogs() {
//   const merchantStore = useMerchantStore();
//   const queryClient = useQueryClient();

//   return useMutation(["bigLogs"], (data: { customerCarId: number }) => {
//     return axios.get(
//       `/backend/merchants/${merchantStore.selectedMerchant}/customer-cars/${data.customerCarId}/bid-logs`
//     );
//   });
// }

export function useBidLogs(data: { skip?: number; take?: number; customerCarId: number }) {
  const authStore = useAuthStore();
  const merchantStore = useMerchantStore();

  return useQuery(["bigLogs", data, merchantStore.selectedMerchant], async () => {
    if (!authStore.token || !merchantStore.selectedMerchant) return;

    const response = await axios.get<{ logs: []; total: number }>(
      `/backend/merchants/${merchantStore.selectedMerchant}/customer-cars/${data.customerCarId}/bid-logs`
    );

    return response.data;
  });
}
